module.exports = "/assets/top_visual.jpg";